import { useQuery } from "@tanstack/react-query";

import { fetchDashboard } from "@/services/booking";
import {
  fetchGuestPassHistory,
  fetchUserGuestPasses,
} from "@/services/finance";
import { fetchUserPromos } from "@/services/user";

export const DashboardQueryKey = ["dashboard"];
export const PromosQueryKey = ["promos"];
export const GuestPassesQueryKey = ["guestpasses"];
export const GuestPassHistoryQueryKey = ["guestpasshistory"];

export const useHomeDataQuery = () => {
  const dashboard = useQuery({
    queryKey: DashboardQueryKey,
    queryFn: fetchDashboard,
  });
  const promos = useQuery({
    queryKey: PromosQueryKey,
    queryFn: fetchUserPromos,
  });
  const guestPasses = useQuery({
    queryKey: GuestPassesQueryKey,
    queryFn: fetchUserGuestPasses,
  });
  const guestPassesHistory = useQuery({
    queryKey: GuestPassHistoryQueryKey,
    queryFn: fetchGuestPassHistory,
  });
  return { dashboard, promos, guestPasses, guestPassesHistory };
};
